const div = document.getElementById('calmac-map');
const isStatic = div?.getAttribute('data-is-static');
const routeCode = div?.getAttribute('data-route-code');

const mapConfig = {
  isStatic: !!isStatic,
  routeCode,
};

export default mapConfig;
